// DS6.1.2
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import s from './SelectionListCard.scss';
var SelectionListCard = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT, className: c(s['root'], className) },
        React.createElement("div", { className: s['content'] }, children)));
};
SelectionListCard.displayName = 'SelectionListCard';
export default SelectionListCard;
//# sourceMappingURL=SelectionListCard.js.map